// extracted by mini-css-extract-plugin
module.exports = {"MainTab":"MainTab_MainTab__16ZEn","Active":"MainTab_Active__2waN7","Disabled":"MainTab_Disabled__2aMNT","Inner":"MainTab_Inner__3R-B2","Description":"MainTab_Description__PnPY7"};